export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const DASHBOARD = "/";
export const ACCOUNT = "/account";
export const PASSWORD_FORGET = "/password-reset";
export const ADMIN = "/admin";
export const ADMIN_DETAILS = "/admin/:id";
